/**
 * @description
 * The company input will go fetch automatically the ID of a company by his name
 *
 * @param {div} input
 */

function BusinessInput(container, company, locale, focus, callback) {
  // Elements
  this.$container = container;
  this.$input = this.$container.find('input#business-id');
  this.$siren = this.$container.find('#number');
  this.$results = this.$container.find('.results');
  this.$loader = this.$results.find('.skeleton');
  this.$companies = this.$results.find('.companies');
  this.$zero = this.$results.find('.no-result');
  this.$focus = focus;

  // Variables
  this.endpoint = '/data-providers/';
  this.previousQuery = null;
  this.previousSearch = null;
  this.selection = -1;
  this.companies = [];
  this.locale = parseLocale(locale);
  this.callback = callback;
  if (!company) {
    company = this.fetchQueryParams();
  }
  if (company) {
    this.onSelection(company);
  }

  this.$input.on('blur', $.proxy(this.onBlur, this));
  this.$input.on('keydown', $.proxy(this.onKeyDown, this));

  if (this.locale === 'EN' || this.locale === 'FR' || this.locale === 'DE') {
    this.$companies.on('mousedown', $.proxy(this.onMouseDown, this));
    this.onBlur();
  } else if (this.locale === 'IT') {
    this.$businessId = new IMask(this.$input[0], { mask: '00000000000' });
    this.company = { code: { id: this.$input.val(), type: 'cfiscale' } };
    this.setLoading(false);
    this.$results.hide();
  } else if (this.locale === 'ES') {
    this.$businessId = new IMask(this.$input[0], { mask: 'a00000000' });
    this.company = { code: { id: this.$input.val(), type: 'nif' } };
    this.setLoading(false);
    this.$results.hide();
  } else if (this.locale === 'NL') {
    this.$businessId = new IMask(this.$input[0], { mask: /^\d{0,8}$/ });
    this.company = { code: { id: this.$input.val(), type: 'kvk' } };
    this.setLoading(false);
    this.$results.hide();
  }

}

BusinessInput.prototype.fetchQueryParams = function() {
  const params = {
    'city': '',
    'code': {
      'id': '',
      'type': ''
    },
    'name': ''
  };
  params.code.id = getParameterByName('id');
  params.code.type = getParameterByName('type');
  params.name = getParameterByName('company');

  return params;
}

BusinessInput.prototype.onBlur = function() {
  var input = this.$input.val() && this.$input.val().replace(/\s*/g, '');

  this.$results.hide();
  this.selection = -1;
  this.$results.find('.selected').removeClass('selected');

  if (this.locale === 'EN' || this.locale === 'FR') var type = 'siren';
  if (this.locale === 'DE') var type = 'crefo';

  if (this.locale === 'EN' || this.locale === 'FR' || this.locale === 'DE') {
    if (/^\d{9}$/.test(input)) {
      this.company = { code: { id: input , type: type } };
      this.$input.val(input.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
    } else if (this.company && this.company.name !== this.$input.val()) {
      this.company = null;
      this.$input.val('');
    } else if (!this.company) {
      if (this.companies.length) {
        this.onSelection(this.companies[0]);
      } else {
        this.$input.val('');
      }
    }

  } else {
    this.company.code.id = this.$input.val();
  }
}

BusinessInput.prototype.onMouseDown = function(e) {
  var target = $(e.target);

  e.preventDefault(); // Won't call blur on this

  if (!target.hasClass('entry')) {
    target = target.parents('.entry');
  }
  this.onSelection(this.companies[target.index()]);
  this.$input.blur();
}

BusinessInput.prototype.onKeyDown = function(e) {
  var _this = this;
  var key = e.which;

  if (this.locale === 'EN' || this.locale === 'FR' || this.locale === 'DE') {
    if (key === 38 || key === 40) {
      e.preventDefault();
      this.setSelection(key);
    } else if (key === 13) {
      this.onSelection(this.companies[0]);
      this.$input.blur();
      e.preventDefault();
    } else if (key === 27) {
      this.$input.blur();
    } else {
      this.setLoading(true);

      if (this.previousSearch) {
        clearTimeout(this.previousSearch);
      }

      if ( this.locale !== 'DE' ){
        this.previousSearch = setTimeout(function() {
          _this.queryDataProviders(_this.$input.val());
        }, 200);
      }else if( this.$input.val().length >= 2 ){
        this.previousSearch = setTimeout(function() {
          _this.queryDataProviders(_this.$input.val());
        }, 500);
      }
    }
  } else if (key === 13) {
    e.preventDefault();
    if (this.callback) {
      this.callback();
    }
  }
}

BusinessInput.prototype.onSelection = function(company) {
  if (company && company.code.id) {
    var chunkedId = company.code.id.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    this.company = company;
    if (this.locale === 'DE') {
      this.$input.val(company.name);
    }else{
      this.$input.val(chunkedId);
    }
    this.$siren.html(chunkedId);
    this.$siren.show();
    if (this.$focus) {
      this.$focus.focus();
    }
  } else {
    this.$input.val('');
    this.$siren.hide();
  }
}

/**
 * @description
 * Query IRIS database and return a formatted array of companies
 *
 * @param {String} name
 */

BusinessInput.prototype.queryDataProviders = function(nameOrCode) {
  var endpoint = this.endpoint;
  var isCode = /^\d{9}$/.test(nameOrCode.replace(/ /g, ''));
  var _this = this;
  if (this.previousQuery) {
    this.previousQuery.abort();
  }

  if (isCode) {
    nameOrCode = { code: nameOrCode.replace(/ /g, '') };
  }

  if ($.isPlainObject(nameOrCode)) {
    if (nameOrCode.name) {
      endpoint += '?company=' + nameOrCode.name.toLowerCase() + '&locale=' + this.locale;
    } else if (nameOrCode.code) {
      endpoint += '?code=' + nameOrCode.code.toLowerCase() + '&locale=' + this.locale;
    }
  } else { // nameOrCode is the name
    endpoint += '?company=' + nameOrCode.toLowerCase() + '&locale=' + this.locale;
  }

  this.previousQuery = $.get(endpoint);

  if ($.isPlainObject(nameOrCode) && nameOrCode.code) {
    this.previousQuery.done(function(data) {
      _this.parseCompanies(data, true);
    });
  } else {
    this.previousQuery.done($.proxy(this.parseCompanies, this));
  }
}

BusinessInput.prototype.parseCompanies = function(data, autoSelection) {
  this.setLoading(false);
  this.companies = data.companies.map(function(entry) {
    var company = {
      name: entry.name,
      code: entry.code,
      city: '&nbsp;'
    };

    if ($.isArray(entry.establishments) && entry.establishments.length) {
      var establishment = entry.establishments.shift();
      if(establishment.address && establishment.address.city){
        company.city = establishment.address.city;
      }
    } else if (entry.address.city != undefined){
      company.city = entry.address.city;
    }
    return company;
  });

  if (this.companies.length === 0) {
    this.$zero.show();
  } else {
    if (autoSelection === true) {
      this.onSelection(this.companies[0]);
      this.$input.blur();
    } else {
      this.refreshResults();
    }
  }
}

BusinessInput.prototype.setSelection = function(key) { // key is either 38 (up) or 40 (down)
  this.selection += (key === 40 || key === undefined) ? (1) : (-1);
  this.$companies.find('.selected').removeClass('selected');
  if (this.locale === 'DE') {
    this.$companies.find('.siren').hide();
  }

  if (this.selection >= this.$companies.find('.entry').length) {
    this.selection = -1;
  }
  if (this.selection < -1) {
    this.selection = this.$companies.find('.entry').length - 1;
  }

  if (this.selection === -1) {
    this.$input.focus();
  } else {
    this.$companies.find('.entry').eq(this.selection).addClass('selected');
  }

  $('section#questionnaire form').css('z-index', 0);
  $('section#questionnaire .actions').css('z-index', 0);
}

BusinessInput.prototype.setLoading = function(state) {
  if (state === true) {
    this.$companies.empty();
    this.$results.show();
    this.$loader.show();
    this.$zero.hide();
    $('section#questionnaire form').css('z-index', 1);
    $('section#questionnaire .actions').css('z-index', -1);
  } else {
    this.$loader.hide();
  }
}

BusinessInput.prototype.refreshResults = function() {
  this.$companies.empty();
  this.$zero.hide();

  this.companies.forEach(function(company) {
    var siren = company.code.id.replace(/(\S{3})/g,'$1 ').slice(0, -1);

    this.$companies.append("<div class='entry'><div class='name overflow-ellipsis'>" + company.name + "</div><div class='siren'>" + siren + "</div><div class='city overflow-ellipsis'>" + company.city + "</div></div>");
  }, this);
  this.setSelection();
}

BusinessInput.prototype.isComplete = function() {
  var isMasked = !!this.$businessId && !!this.$businessId.masked;
  var hasCompany = !!this.company && !!this.company.code && !!this.company.code.id;

  if (isMasked) {
    return this.$businessId.masked.isComplete;
  }

  return hasCompany;
}
